<template>
  <div>
    <base-list-management
      ref="enterprisePlanList"
      :configData.sync="config"
    >
      <template #custom-operate>
        <div v-if="judgePermission('enterprise_plan_create')" class="operation-box">
          <el-button type="primary" @click="goCreate">新增方案</el-button>
        </div>
      </template>
    </base-list-management>
  </div>
</template>

<script>
import enterprisePlanListConfig from './listConfig'
import { updateEnterprisePlanState } from '@/api/domain/leaseScheme'
import { ENTERPRISE_PLAN_STATUS } from './const'

export default {
  name: 'EnterprisePlanList',
  data() {
    const config = enterprisePlanListConfig.call(this)
    return {
      config,
      isFirstLoad: true,
    }
  },

  activated() {
    if (this.isFirstLoad) {
      this.isFirstLoad = false
      return
    }
    this.$refs.enterprisePlanList?.reset()
  },
  methods: {
    // 搜索参数处理：映射 brandSeriesModel → brandId/seriesId/modelId
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearch(params) {
      const { brandSeriesModel } = params
      const searchParams = {
        ...params,
        brandId: brandSeriesModel?.brandId,
        seriesId: brandSeriesModel?.seriesId,
        modelId: brandSeriesModel?.modelId,
      }
      delete searchParams.brandSeriesModel
      return searchParams
    },

    // 自定义重置：重置品牌车系组件
    // eslint-disable-next-line vue/no-unused-properties
    customizeReset() {
      this.$refs.enterprisePlanList.setItemData({
        elConfigKey: 'value',
        key: 'brandSeriesModel',
        data: {},
      })
    },

    // 上架/下架
    // eslint-disable-next-line vue/no-unused-properties
    handleToggleState(row, targetState) {
      const actionText = targetState === ENTERPRISE_PLAN_STATUS.ON ? '上架' : '下架'
      this.$confirm(`确认${actionText}该企业租赁方案【${row.name}】？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async () => {
        const { code } = await updateEnterprisePlanState({
          id: row.id,
          state: targetState,
        })
        if (code === 1) {
          this.$message.success(`方案已${actionText}`)
          setTimeout(() => {
            this.$refs.enterprisePlanList.searchForm()
          }, 3000)
        }
      }).catch(() => {
        // 用户取消操作,无需处理
      })
    },

    // 新增
    // eslint-disable-next-line vue/no-unused-properties
    goCreate() {
      this.$router.push({
        path: '/car_to_lease/enterprisePlan/form',
        query: { mode: 'create' },
      })
    },

    // 编辑
    // eslint-disable-next-line vue/no-unused-properties
    goEdit(row) {
      this.$router.push({
        path: '/car_to_lease/enterprisePlan/form',
        query: { mode: 'edit', id: row.id },
      })
    },

    // 复制
    // eslint-disable-next-line vue/no-unused-properties
    goCopy(row) {
      this.$router.push({
        path: '/car_to_lease/enterprisePlan/form',
        query: { mode: 'copy', id: row.id },
      })
    },

    // 详情
    // eslint-disable-next-line vue/no-unused-properties
    goDetail(row) {
      this.$router.push({
        path: '/car_to_lease/enterprisePlan/detail',
        query: { id: row.id },
      })
    },

  },
}
</script>
